module.exports = __webpack_public_path__ + "static/media/blushed_mango.5c8ba7d0.png";